import { useSelector } from 'react-redux'

import { selectAgentsByIdOrChatId } from 'ducks/chat/selectors/users'

import IntegrationAction from 'components/App/DesktopView/Layout/TicketInspector/Changesets/ExpandedMessage/IntegrationAction'

import IntegrationEventWrapper from './Wrapper'

export default function IntegrationEvent({ mxEvent }) {
  const senderUserId = mxEvent.getSender()
  const agentsByChatId = useSelector(selectAgentsByIdOrChatId)
  const { username = '' } = agentsByChatId[senderUserId] || {}
  const content = mxEvent.getContent()

  return (
    <IntegrationEventWrapper provider={content.provider}>
      {username && `@${username} `}
      {'  '}
      <IntegrationAction change={content} />
    </IntegrationEventWrapper>
  )
}
